import { ReactNode } from "react";

/**
 * LegendTagItemComponent
 */

type Props = {
  icon: ReactNode,
  label: string,
};

export const LegendTagItemComponent = ({
  icon,
  label,
}: Props) => {
  return (
    <div className="flex flex-row items-center gap-1">
      {icon}
      <span
        className="text-[.75rem] text-black dark:text-white">
        {label}
      </span>
    </div>
  );
}